import {XliffMerge} from './xliff-merge';
/**
 * Created by martin on 15.02.2017.
 * Command line interface xliffmerge
 */

XliffMerge.main(process.argv);
